// extracted by mini-css-extract-plugin
module.exports = {"root":"CheckBox_root__3ufjH","selected":"CheckBox_selected__3pN34"};